import React from "react";
import styled from "styled-components";
import Link from "./atoms/Link";
import { getThemeColor } from "../utils";

const ArrowWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1rem;
  border-radius: .15rem;
  border: .125rem solid ${({ theme, color }) => theme.colors[color]};
  margin-right: 1rem;
`;

const Bar = styled.div`
  height: .125rem;
  width: .75rem;
  background-color: ${({ theme, color }) => theme.colors[color]};
`;

const Arrow = styled.div`
  border-top: .25rem solid transparent;
  border-bottom: .25rem solid transparent;
  border-left: .25rem solid ${({ theme, color }) => theme.colors[color]};
`;

const Body = styled.div`
  color: inherit;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
`;

export const ArrowBody = ({ children, color = "teal" }) =>
  <Body>
    <ArrowWrapper color={color}>
      <Bar color={color} />
      <Arrow color={color} />
    </ArrowWrapper>
    {children}
  </Body>;

export default ({ color = "teal", children, to = "/" }) =>
  <Link to={to} color={color}>
    <ArrowBody color={color}>
      {children}
    </ArrowBody>
  </Link>;



// WEBPACK FOOTER //
// ./src/components/ArrowLink.js